import api from "./Api";

const serializeParams = (params) => {
  const searchParams = new URLSearchParams();
  for (const key in params) {
    const value = params[key];
    if (Array.isArray(value) && value.length > 0) {
      value.forEach((val) => searchParams.append(key, val));
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  }
  return searchParams.toString();
};

export default class RelatorioService {
  listarEncomendas(request, callback) {
    api
      .get(this.host() + "/api/v1/reports/order-data", {
        params: request,
        paramsSerializer: serializeParams,
      })
      .then((response) => {
        callback(null, response.data);
      })
      .catch((erro) => {
        callback(erro, null);
      });
  }

  exportarEncomendasCSV(params, callback) {
    api
      .get(this.host() + "/api/v1/reports/order-data", {
        params: { ...params, download: true },
        paramsSerializer: serializeParams,
        responseType: "blob",
      })
      .then((response) => {
        callback(null, response.data);
      })
      .catch((erro) => {
        callback(erro, null);
      });
  }

  listarCotacoes(request, callback) {
    api
      .get(this.host() + "/api/v1/reports/quotation-report", {
        params: request,
        paramsSerializer: serializeParams,
      })
      .then((response) => callback(null, response.data))
      .catch((erro) => callback(erro, null));
  }

  exportarCotacoesCSV(params, callback) {
    api
      .get(this.host() + "/api/v1/reports/quotation-report", {
        params: { ...params, download: true },
        paramsSerializer: serializeParams,
        responseType: "blob",
      })
      .then((response) => callback(null, response.data))
      .catch((erro) => callback(erro, null));
  }

  host() {
    return process.env.REACT_APP_HOST_API;
  }
}
